var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWavingFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2098_84690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.70312 1.34424H8.20312C8.40204 1.34424 8.5928 1.42326 8.73345 1.56391C8.87411 1.70456 8.95312 1.89533 8.95312 2.09424V3.59424H16.4531C16.8656 3.59424 16.9399 3.80499 16.6174 4.06299L11.5781 8.09424L17.2031 12.5942H6.40312C6.34164 12.5943 6.28108 12.5793 6.22677 12.5505C6.17247 12.5216 6.12608 12.4799 6.09171 12.4289C6.05733 12.3779 6.03601 12.3193 6.02963 12.2581C6.02325 12.197 6.03201 12.1352 6.05513 12.0782C6.57563 10.7897 8.95312 10.3442 8.95312 10.3442H3.70312",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 3.59424V10.3442",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.20312 0.594238V17.8442",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2098_84690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.703125 0.219238)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingFlag);
export default __webpack_public_path__ + "static/media/waving-flag.f7c0e5a4fbb93493b265b56ddde0c49f.svg";
export { ForwardRef as ReactComponent };